export default "__VITE_ASSET__DHgKC6SQ__"